import React from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import PropTypes from 'prop-types'

import './footer.css'

const Footer = (props) => {
  return (
    <div className={`footer-container1 ${props.rootClassName} `}>
      <footer className="footer-thq-footer-root-elm footer-root">
        <div className="footer-container">
          <div className="footer-main-grid">
            <div className="footer-brand-column">
              <a href="Homepage">
                <div className="footer-logo-link">
                  <span className="footer-logo-text">California Places</span>
                </div>
              </a>
              <p className="footer-brand-description section-content">
                Property intelligence, only for California
              </p>
            </div>
            <div className="footer-nav-column">
              <h3 className="footer-column-title section-subtitle">
                Quick Links
              </h3>
              <nav className="footer-nav-list">
                <a href="Homepage">
                  <div className="footer-nav-link">
                    <span>Home</span>
                  </div>
                </a>
                <a href="#contact">
                  <div className="footer-nav-link">
                    <span>Contact Us</span>
                  </div>
                </a>
              </nav>
            </div>
            <div className="footer-nav-column">
              <h3 className="footer-column-title section-subtitle">Contact</h3>
              <div className="footer-contact-info">
                <div className="footer-contact-item">
                  <svg
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                      <circle r="3" cx="12" cy="10"></circle>
                    </g>
                  </svg>
                  <span className="section-content">Berkeley CA</span>
                </div>
                <div className="footer-contact-item">
                  <svg
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                      <rect x="2" y="4" rx="2" width="20" height="16"></rect>
                    </g>
                  </svg>
                  <span className="section-content">
                    support@focusreintel.com
                  </span>
                </div>
              </div>
              <div className="footer-legal-links">
                <Link to="/privacy">
                  <div className="footer-thq-footer-nav-link-elm3 footer-nav-link">
                    <span>Privacy Policy</span>
                  </div>
                </Link>
                <Link to="/terms-of-service">
                  <div className="footer-thq-footer-nav-link-elm4 footer-nav-link">
                    <span>Terms of Service</span>
                  </div>
                </Link>
              </div>
            </div>
            <div className="footer-download-column">
              <h3 className="footer-column-title section-subtitle">
                Get the App
              </h3>
              <div className="footer-download-wrapper">
                <div className="footer-store-buttons">
                  <a href="https://apps.apple.com/us/app/california-places/id6757087852">
                    <img
                      alt={props.imageAlt}
                      src={props.imageSrc}
                      className="footer-image1"
                    />
                  </a>
                </div>
                <div className="footer-thq-footer-qr-container-elm footer-qr-container"></div>
              </div>
              <a href="https://play.google.com/store/apps/details?id=focusreintel.com.focus&amp;hl=en_US">
                <img
                  alt={props.imageAlt1}
                  src={props.imageSrc1}
                  className="footer-image2"
                />
              </a>
            </div>
          </div>
          <div className="footer-bottom-bar">
            <p className="footer-copyright section-content">
              {' '}
              ©2026 California Places LLC. All rights reserved. Built for
              California.
            </p>
            <div className="footer-bottom-accent"></div>
          </div>
        </div>
      </footer>
      <div className="footer-container2">
        <div className="footer-container3">
          <Script
            html={`<script defer data-name="footer-interactions">
(function(){
  const footerSocialIcons = document.querySelectorAll(".footer-social-icon")
  footerSocialIcons.forEach((icon) => {
    icon.addEventListener("mouseenter", () => {
      icon.style.transform = "translateY(-5px) scale(1.1)"
    })
    icon.addEventListener("mouseleave", () => {
      icon.style.transform = "translateY(0) scale(1)"
    })
  })

  const storeButtons = document.querySelectorAll(".footer-store-btn")
  storeButtons.forEach((btn) => {
    btn.addEventListener("mouseenter", () => {
      btn.style.boxShadow = "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)"
    })
    btn.addEventListener("mouseleave", () => {
      btn.style.boxShadow = "none"
    })
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

Footer.defaultProps = {
  imageAlt1: 'image',
  imageAlt: 'image',
  imageSrc1: '/functions/googleicon-200h.png',
  rootClassName: '',
  imageSrc: '/applestore-200h.png',
}

Footer.propTypes = {
  imageAlt1: PropTypes.string,
  imageAlt: PropTypes.string,
  imageSrc1: PropTypes.string,
  rootClassName: PropTypes.string,
  imageSrc: PropTypes.string,
}

export default Footer
